module.exports = __webpack_public_path__ + "img/books.9c30fb7e.svg";